import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const BillingPurchaseOrderWrapper = styled.div`
  padding: 24px 16px;
  ${responsive.MOBILE`
    padding: 16px 8px;
  `}
`;
